"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractRequestType = void 0;
var util_1 = require("../../util");
function extractRequestType(query) {
    var type_id = util_1.tryGetValue(query.type_id);
    var team_id = util_1.tryGetValue(query.team_id);
    if (!type_id) {
        return {
            name: 'request_types',
        };
    }
    return {
        name: 'request_type',
        type_id: type_id,
        team_id: team_id,
    };
}
exports.extractRequestType = extractRequestType;
